<template>
  <div class="condition">
    <el-checkbox v-model="checked" :true-label="trueVal" :false-label="falseVal" @change="change">{{label}}</el-checkbox>
  </div>
</template>
<script>
    export default {
        props: {
          value: [String, Object, Number, Boolean],
          label: String,
          trueVal: [String, Number],
          falseVal: [String, Number]
        },
        data () {
            return {
              checked: this.value || false
            }
        },
        computed: {},
        watch: {
          value (val) {
            this.checked = val
          }
        },
        mounted () {
        },
        methods: {
          change (val) {
            this.$emit('input', val)
            this.$emit('change', val)
          }
        }
    }
</script>
<style lang="scss" scoped>
  .condition {
    margin-left: 30px;
  }
</style>
